import { render, staticRenderFns } from "./EmailQueue.vue?vue&type=template&id=006f0d4e&"
import script from "./EmailQueue.vue?vue&type=script&lang=ts&"
export * from "./EmailQueue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports